import { getExportAssessmentsPromises } from './exportAssessments';
import { getExportProgressionsPromises } from './exportProgressions';
import { getExportCoachingStatsPromises } from './exportCoachingStats';
import { getExportRecommendationParametersPromises } from './exportRecommendationParameters';
import { dataImportCommon } from './importCommon';
import { CollectionTypes } from '~/types/adamTypes';

import type { NomadDB } from '~/db/NomadDB';

export const dataExportImportCommon = (
  db: NomadDB,
  nomadFetch: Function,
  isAdaptiveEnabled: boolean = false
) => {
  const {
    importCoachingStats,
    importTrophies,
    importProgressions,
    importChallenges,
    importLibrary,
    importLibraryBooks,
    importMediaCommon,
    importAssessments,
    importRecommendations,
    importRecommendationParameters,
  } = dataImportCommon(db, nomadFetch);

  const exportAssessments = async () => {
    await getExportAssessmentsPromises(db, nomadFetch);
  };

  const exportImportAssessments = async () => {
    await exportAssessments();
    await importAssessments();
  };

  const exportRecommendationParameters = async (isAdaptiveEnabled: boolean) => {
    if (!isAdaptiveEnabled) return;
    await getExportRecommendationParametersPromises(db, nomadFetch);
  };

  const exportImportRecommendationParameters = async (
    isAdaptiveEnabled: boolean
  ) => {
    await exportRecommendationParameters(isAdaptiveEnabled);
    await importRecommendationParameters(isAdaptiveEnabled);
  };

  const exportProgressions = async () => {
    await getExportProgressionsPromises(db, nomadFetch);
  };

  const exportImportProgressions = async () => {
    await exportProgressions();
    await importProgressions();
  };

  const exportCoachingStats = async () => {
    await getExportCoachingStatsPromises(db, nomadFetch);
  };

  const exportImportCoachingStats = async () => {
    await exportCoachingStats();
    await importCoachingStats();
  };

  const getExportImportCollectionsCall = (collection): Function => {
    switch (collection) {
      case CollectionTypes.Library:
        return async () => await importLibrary();

      case CollectionTypes.LibraryBooks:
        return async () => await importLibraryBooks();

      case CollectionTypes.Trophies:
        return async () => await importTrophies();

      case CollectionTypes.Challenges:
        return async () => await importChallenges(isAdaptiveEnabled);

      case CollectionTypes.Recommendations:
        return async () => await importRecommendations(isAdaptiveEnabled);

      case CollectionTypes.Media:
        return async () => await importMediaCommon();

      case CollectionTypes.Progressions:
        return async () => await exportImportProgressions();

      case CollectionTypes.Assessments:
        return async () => await exportImportAssessments();

      case CollectionTypes.RecommendationParameters:
        return async () =>
          await exportImportRecommendationParameters(isAdaptiveEnabled);

      case CollectionTypes.CoachingStats:
        return async () => await exportImportCoachingStats();
    }
  };

  const getExportImportCollectionsCalls = (collections): Function[] => {
    collections = Array.isArray(collections) ? collections : [collections];
    const calls = [];
    collections.forEach((collection) => {
      calls.push(getExportImportCollectionsCall(collection));
    });
    return calls;
  };

  return {
    exportImportAssessments,
    exportImportProgressions,
    getExportImportCollectionsCalls,
    exportProgressions,
    exportAssessments,
    exportCoachingStats,
  };
};
